/// <reference types="vite/client" />
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import RootApp from "./RootApp";
import { installMediaRefresh } from "../../surfacekit/mediaRefresh.js";
import AdminApp from "./platform/AdminApp";
import "./fonts";
import "./tokens.css";
import "./app.css";

installMediaRefresh(document, url => url.origin === location.origin);

async function render() {
  // A local-only fake Hub exercises the real Agent shell and chat route. It is
  // excluded from production by Vite's DEV constant and never talks to an Agent.
  if (import.meta.env.DEV && location.hostname === "127.0.0.1" && new URLSearchParams(location.search).has("fake-chat")) {
    const { installFakeChatBackend } = await import("./dev/fakeChatBackend");
    installFakeChatBackend();
    const { default: App } = await import("./App");
    createRoot(document.getElementById("root")!).render(<App />);
    return;
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      {location.pathname === "/admin" || location.pathname.startsWith("/admin/") ? <AdminApp /> : <RootApp />}
    </StrictMode>,
  );
}
void render();
